import moment from 'moment';
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {Epsonfont} from '@/assets/fonts/Epson1-normal'
import {Epsonfontbold} from '@/assets/fonts/Epson1-bold'

var document_headerCustomFormat = {
  async print(endPoint, docId, isDefaultPrint, customFont){
    // get document_header
    let component_x = {}
    component_x.endPoint = endPoint
    const document_header = await HTTPRequest.getRequest(component_x.endPoint + "documents/" + docId, null);

    // init header values
    let requestingSiteName = document_header.site_id.label;
    let requestingSiteId = document_header.site_id.key;
    let supplier = document_header.supplier_id;
    let currentDocumentTypeFriendlyCode = document_header.friendly_code;
    let documentType = document_header.document_name
    let documentNumber = document_header.document_no || ''
    let documentDate = moment(document_header.document_date).format('D-MMM-YYYY') || ''
    let targetDate = moment(document_header.target_date).format('D-MMM-YYYY') || ''
    let cancellationDate = moment(document_header.cancellation_date).format('D-MMM-YYYY') || ''
    let printDate = moment().format('lll') || '';
    let postDate = ""
    if (document_header.posted_at != null){
      postDate = document_header.posted_at;
    }
    let referenceLabel = "Reference";
    let reference = document_header.reference;
    let currencyLabel = document_header.currency_id.label;
    let currencyRate = document_header.currency_rate;
    let documentStatus = document_header.status;
    let remark = document_header.remark || ''
    let createdBy = document_header.created_by || '';
    let postedBy = document_header.posted_by || '';
    let purpose = ""
    if (document_header.purpose_id.label == null){
      purpose = ''
    } else {
      purpose = document_header.purpose_id.label || ''
    }

    let userCode = secureStorage.getItem("userCode") || '';

    // get details
    let document_lines = await HTTPRequest.getRequest(component_x.endPoint + "document_lines/" + docId + "?field_name=document_id&sort=size", null);

    // get data
    let siteData = await HTTPRequest.getRequest(`${component_x.endPoint}sites/${requestingSiteId}` , null, null);
    let supplierData = await HTTPRequest.getRequest(`${component_x.endPoint}suppliers/${supplier.key}`, null, null);

    // --- Access Cost / Price masking (Access Cost module = system_module_id 123) ---
    // 'Z' = access to cost values, 'Y' = access to price values.
    let accessCostPriceRights = []
    try {
      let accessCostPriceRightsRequest = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
      if (accessCostPriceRightsRequest && accessCostPriceRightsRequest.access_rights && accessCostPriceRightsRequest.access_rights[123]) {
        accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
      }
    } catch (e) {
      accessCostPriceRights = []
    }

    // Determine the document's price/cost choice to apply the same gating the app uses elsewhere.
    let productPriceChoice = 'landed_cost'
    try {
      if (document_header.document_type_id) {
        let docTypeSettings = await HTTPRequest.getRequest(component_x.endPoint + '/document_types/get_document_type_settings?id=' + document_header.document_type_id, null)
        if (docTypeSettings && docTypeSettings.document_type_settings && docTypeSettings.document_type_settings.priceOrCost) {
          productPriceChoice = String(docTypeSettings.document_type_settings.priceOrCost)
            .replace(/\s+/g, '_')
            .replace(/([a-z])([A-Z])/g, '$1_$2')
            .toLowerCase()
        }
      }
    } catch (e) {
      productPriceChoice = 'landed_cost'
    }

    let noZ = !accessCostPriceRights.includes('Z')
    let noY = !accessCostPriceRights.includes('Y')
    // Unit Cost / Total Cost hidden when the user lacks the cost right.
    let hideCost = noZ
    // Ext Cost / Subtotal hidden per the cost/price choice rule.
    let hideSubtotal = (noZ && (productPriceChoice == 'landed_cost' || productPriceChoice == 'ordering_cost' || productPriceChoice == 'original_cost')) ||
                       (noY && (productPriceChoice == 'retail_price' || productPriceChoice == 'wholesale_price'))
    let maskValue = '***'

    // load account settings
    component_x.printFontSizeIncrease = 0
    let AccountSettings = await HTTPRequest.getRequest(component_x.endPoint + 'settings?code=accountSettings&status=A', null)
    if(AccountSettings.length > 0){
      let as = JSON.parse(AccountSettings[0].value)
      let printFontSize = as.printSettingsFontSizePTPM
      if(printFontSize != null){
        component_x.printFontSizeIncrease = printFontSize
      }
    }
    let fontSizeIncreaser = component_x.printFontSizeIncrease || 0

    // need to replace later on based on db save.
    const paperSize = "a4"
    const orientation = 'portrait'
    let doc = new jsPDF({ orientation: orientation, unit: 'mm', format: paperSize });

    // add dot matrix font
    doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
    doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
    doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
    doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');

    // declare header style
    let hdStyles = {
      lineWidth: 0.15,
      cellPadding: 2,
      fontSize: 8 + fontSizeIncreaser
    }

    // declare style
    let styles = {
      fontSize: 7 + fontSizeIncreaser
    }

    // make a dynamic column width based on number of columns
    let default_column_no = 11 
    let max_table_width = 180 // if portrait
    let col_width = max_table_width / default_column_no // column equal width

    let headerCustomPosition = 0
    
    if(customFont == 'dotMatrix'){
      doc.setFont("Epson1");
      hdStyles.font = 'Epson1';
      styles.font = 'Epson1';
      headerCustomPosition = -10;
    }

    let header_position = 130 + headerCustomPosition
    let value_position = 170

    let logobarter = document.getElementById('logobarter');
    doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
    doc.setFontStyle("bold");
    doc.setFontSize(14 + fontSizeIncreaser);
    doc.text(requestingSiteName, 40, 25);

    doc.setFontSize(9 + fontSizeIncreaser);
    const companyName = siteData.company_name || '';
    const companyAddress = siteData.company_address || '';
    const companySplitTitle = doc.splitTextToSize(`Company Name: ${companyName}\nAddress: ${companyAddress}`, 75);
    doc.text(40, 30, companySplitTitle);

    doc.setFontSize(10 + fontSizeIncreaser);
    doc.setFontStyle("bold");
    const supplierName = supplierData.name || '';
    const supplierAddress = supplierData.billing_address || '';
    const tin = supplierData.tin || '';
    let splitTitle = doc.splitTextToSize(`Supplier: ${supplierName}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 90);
    doc.text(15, 50, splitTitle);
    doc.setFontStyle("normal");

    doc.setFontStyle("normal");
    doc.text(documentType, header_position, 25);
    doc.text("# "+String(documentNumber), header_position, 35);
    doc.setFontSize(8 + fontSizeIncreaser);

    doc.setFontSize(10 + fontSizeIncreaser);
    doc.text(currentDocumentTypeFriendlyCode+" Date:", header_position, 50);
    doc.text(documentDate, value_position, 50);
    doc.text("Target Date:", header_position, 55);
    doc.text(targetDate, value_position, 55);
    let x_position = 60
    doc.text("Cancellation  Date:", header_position, x_position);
    doc.text(cancellationDate, value_position, x_position);
    doc.text(`${referenceLabel}:`, header_position, x_position + 5);
    doc.text(reference, value_position, x_position + 5);
    doc.text("Currency:", header_position, x_position + 10);
    doc.text(currencyLabel, value_position, x_position + 10);
    doc.text("Currency Rate:", header_position, x_position + 15);
    doc.text(currencyRate, value_position, x_position + 15);
    doc.text("Status:", header_position, x_position + 20);
    doc.text(documentStatus, value_position, x_position + 20);
    doc.text("Purpose:", 15,  x_position + 20);
    doc.text(purpose, 40,  x_position + 20);
    doc.text("Remark:", 15, x_position + 25);
    doc.text(remark, 40, x_position + 25);

    let headers = [];
    let headers_tmp = [];

    headers_tmp.push(
      {content: 'Barcode', styles: {halign: 'center', valign: 'top'}},
      {content: 'Class', styles: {halign: 'center', valign: 'top'}},
      {content: 'Sub C', styles: {halign: 'center', valign: 'top'}},
      {content: 'Stock No.', styles: {halign: 'center', valign: 'top'}},
      {content: 'Supplier Stock No.', styles: {halign: 'center', valign: 'top'}},
      {content: 'Color', styles: {halign: 'center', valign: 'top'}},
      {content: 'Size', styles: {halign: 'center', valign: 'top'}},
      {content: 'Qty', styles: {halign: 'center', valign: 'top'}},
      {content: 'Currency', styles: {halign: 'center', valign: 'top'}},
      {content: 'Unit Cost', styles: {halign: 'center', valign: 'top'}},
      {content: 'Ext Cost', styles: {halign: 'center', valign: 'top'}}
    );

    headers.push(headers_tmp)

    // make last 2 column align to right.
    let newStyle = []
    let colStyles = {}
    for(let x=0; x < default_column_no; x++){
      newStyle[x] = {cellWidth: col_width}
      if (x > (default_column_no - 3)){
        Object.assign(newStyle[x], {halign: 'right'})
      } else {
        Object.assign(newStyle[x], {halign: 'center'})
      }

      Object.assign(colStyles, {[x]: newStyle[x]})
    }

    // body (table)
    let reportData = []
    let detail = []
    let reportLine = {}

    let subtotal_qty = 0
    let subtotal_ext = 0

    let grand_qty = 0
    let grand_cost = 0
    let grand_ext = 0

    for(let i=0; i < document_lines.length; i++){
      reportLine = document_lines[i]

      grand_qty = grand_qty + Number(reportLine.quantity)
      grand_cost = grand_cost + Number(reportLine.cost)
      grand_ext = grand_ext + Number(reportLine.subtotal)

      detail = [
        reportLine.barcode,
        reportLine.section_code,
        reportLine.category_code,
        reportLine.stock_no,
        reportLine.ref_code,
        reportLine.color,
        reportLine.size,
        this.convertToCurrency(Number(reportLine.quantity), 0),
        document_header.currency_id.label,
        hideCost ? maskValue : this.convertToCurrency(Number(reportLine.cost), 2),
        hideSubtotal ? maskValue : this.convertToCurrency(Number(reportLine.subtotal), 2)
      ];

      reportData.push(Object.assign({}, detail))

      subtotal_qty = subtotal_qty + Number(reportLine.quantity)
      subtotal_ext = subtotal_ext + Number(reportLine.subtotal)
      let current_grouper = ""
      let next_grouper = ""

      let sub_detail = []
      if(i == document_lines.length-1){
        sub_detail = [
          "   ", "", "", 
          "", "", reportLine.color, "",
          this.convertToCurrency(Number(subtotal_qty), 0),
          "", "",
          hideSubtotal ? maskValue : this.convertToCurrency(Number(subtotal_ext), 2)
        ]

        reportData.push(Object.assign({}, sub_detail))
        reportData.push(Object.assign({}, ["rowLine"]))
      } else {
        current_grouper = reportLine.color
        next_grouper = document_lines[i+1].color
        if(current_grouper != next_grouper){
          sub_detail = [
            "   ", "", "", 
            "", "", reportLine.color, "",
            this.convertToCurrency(Number(subtotal_qty), 0), 
            "", "",
            hideSubtotal ? maskValue : this.convertToCurrency(Number(subtotal_ext), 2)
          ]
  
          reportData.push(Object.assign({}, sub_detail))

          subtotal_qty = 0
          subtotal_ext = 0
        }
      }
    }

    // initial position of table
    let startY = 105

    doc.autoTable({
      startY: startY,
      head: headers,
      body: reportData,
      theme: 'plain',
      tableWidth: 'wrap',
      styles: styles,
      headStyles: hdStyles,
      columnStyles: colStyles,
      margin: { bottom: 30 },
      didParseCell: function(data) {
        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
          data.cell.styles.fillColor = [0, 0, 0]
          data.cell.styles.fontSize = 0.15
          data.cell.styles.cellPadding = 0
        } else if (data.row.section == 'body' && (data.row.raw[0] == '   ')){
          data.cell.styles.fontStyle = 'bold'
        }
      }
    });

    
    let finalY = doc.lastAutoTable.finalY; // The y position on the page

    let dynamic_y = finalY + 15
    let special_y = finalY + 15 // for sign stamp

    doc.setFontStyle("bold");
    doc.setFontSize(7 + fontSizeIncreaser);
    doc.text(15, dynamic_y, "Total Quantity:")
    doc.text(60, dynamic_y, `${grand_qty}`, 'right')
    dynamic_y = dynamic_y + 4
    doc.text(15, dynamic_y, "Total Cost:")
    doc.text(60, dynamic_y, hideCost ? maskValue : `${this.convertToCurrency(Number(grand_cost), 2)}`, 'right')
    dynamic_y = dynamic_y + 4
    doc.text(15, dynamic_y, "Subtotal:")
    doc.text(60, dynamic_y, hideSubtotal ? maskValue : `${this.convertToCurrency(Number(grand_ext), 2)}`, 'right')
    
    dynamic_y = dynamic_y + 2
    doc.line(15, dynamic_y, 220, dynamic_y)
    doc.setFontStyle("normal");
    dynamic_y = dynamic_y + 4

    doc.setFontSize(8 + fontSizeIncreaser);
    doc.text(15, dynamic_y, "Printed By:")
    doc.text(35, dynamic_y, userCode)

    doc.text(70, dynamic_y, "Created By:")
    doc.text(90, dynamic_y, createdBy)

    doc.text(125, dynamic_y, "Posted By:")
    doc.text(145, dynamic_y, postedBy)

    dynamic_y = dynamic_y + 5
    doc.text(15, dynamic_y, "Print Date:")
    doc.text(35, dynamic_y, printDate)

    dynamic_y = dynamic_y + 5
    doc.text(15, dynamic_y, "Post Date:")
    doc.text(35, dynamic_y, `${postDate}`)

    // for special stamp / text
    doc.setFontStyle("normal");
    doc.setFontSize(6 + fontSizeIncreaser);
    doc.text("Noted By:", 75, special_y)
    doc.text("____________________________________", 95, special_y)
    special_y = special_y + 4
    doc.text("Verified By:", 75, special_y)
    doc.text("____________________________________", 95, special_y)
    special_y = special_y + 4
    doc.text("Approved By:", 75, special_y)
    doc.text("____________________________________", 95, special_y)

    let pageCount = doc.internal.getNumberOfPages();

    for(let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8 + fontSizeIncreaser);
        doc.text('Page ' + String(i) + ' of ' + String(pageCount), 180, 290);
    }

    window.open(URL.createObjectURL(doc.output("blob")))
  },
  convertToCurrency(num, scale){
    return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },
}

export default document_headerCustomFormat;